import { __rest } from "tslib";
import React, { useState, useEffect } from 'react';
import { Input, Button, Modal, Popover } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import classnames from 'classnames';
import { apiHolder, apis, YUNXIN_NONE_SENTINEL, } from 'api';
import lodashGet from 'lodash/get';
import ContactIMModal from '@web-common/components/UI/SiriusContact/IMModal';
import { filterContactListByYunxin } from '../../utils/im_team_util';
import CloseIcon from '@web-common/components/UI/Icons/svgs/CloseMailSvg';
import InfoTips from '@web-common/components/UI/Icons/svgs/InfoSvg';
import AvatarTag from '@web-common/components/UI/Avatar/avatarTag';
import styles from './teamCreator.module.scss';
import { openSession } from '../../common/navigate';
import { contactApi, getMainAccount, transContactModel2ContactItem } from '@web-common/components/util/contact';
import { getBodyFixHeight } from '@web-common/utils/constant';
import { getIn18Text } from 'api';
const systemApi = apiHolder.api.getSystemApi();
const imTeamApi = apiHolder.api.requireLogicalApi(apis.imTeamApiImpl);
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const discussApi = apiHolder.api.requireLogicalApi(apis.imDiscussApiImpl);
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const CreatorConf = {
    0: ['enterprise'],
    1: ['enterprise', 'team'],
};
const CreatorLabels = {
    0: {
        creatorTitle: getIn18Text('CHUANGJIANQUNZU'),
        groupTitleLabel: getIn18Text('QUNMINGCHENG'),
        selectGroupMember: getIn18Text('XUANZEQUNCHENGYUAN'),
        placeholder: getIn18Text('QINGSHURUQUNMING11'),
    },
    1: {
        creatorTitle: getIn18Text('FAQIYOUJIANTAO'),
        groupTitleLabel: getIn18Text('TAOLUNZUMINGCHENG'),
        selectGroupMember: getIn18Text('XUANZETAOLUNZU'),
        notInGroupMemberInfo: getIn18Text('GEYOUXIANGDEZHI'),
        notInGroupMemberBtn: getIn18Text('XIANGQING'),
        placeholder: getIn18Text('QINGSHURUTAOLUN'),
    },
};
const TeamCreator = props => {
    const { onCancel, creatorType } = props;
    const [name, setName] = useState('');
    const [curContact, setCurContact] = useState();
    const [selectedList, setSelectList] = useState([]);
    const [otherContact, setOtherContact] = useState([]);
    const [tid, setTid] = useState('');
    const [chosenMembers, setChosenMembers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [userId, setUserId] = useState('');
    const [curMailListIds, setCurMailListIds] = useState();
    useEffect(() => {
        if (creatorType === 1 && userId) {
            mailApi
                .doGetMailContent(props.mid, true, false)
                .then(async (content) => {
                const { receiver, sender, senders } = content, restProps = __rest(content, ["receiver", "sender", "senders"]);
                const accounts = [...receiver, sender].map(item => {
                    return item.contact.contact.accountName;
                });
                const list = await contactApi.doGetServerContactByEmails(accounts);
                const contactModelMap = new Map(list.map(item => {
                    return [item.contact.accountName, item];
                }));
                const newReceive = receiver.map(item => {
                    const email = item.contactItem.contactItemVal;
                    if (!contactModelMap.has(email)) {
                        return item;
                    }
                    const contactModel = contactModelMap.get(email);
                    return Object.assign(Object.assign({}, item), { contact: contactModel });
                });
                const senderEmail = sender.contactItem.contactItemVal;
                const newSender = contactModelMap.has(senderEmail)
                    ? Object.assign(Object.assign({}, sender), { contact: contactModelMap.get(senderEmail) }) : sender;
                content.receiver = newReceive;
                content.sender = newSender;
                content.senders = [newSender];
                return Object.assign(Object.assign({}, restProps), { sender: newSender, senders: [newSender], receiver: newReceive });
            })
                .then((content) => {
                const { entry: { title, tid }, receiver, sender, } = content;
                setName(title.slice(0, 30));
                setTid(tid !== null && tid !== void 0 ? tid : '');
                let contactItems = [];
                let otherContactItems = [];
                let chosenMemberItems = [];
                const doGetContactInMailListParams = {
                    idList: [],
                    emailList: [],
                };
                const members = [...receiver, sender];
                for (let { contact, contactItem, mailMemberType } of members) {
                    if (mailMemberType === 'bcc') {
                        break;
                    }
                    if (contact.contact.type === 'enterprise') {
                        if ([contact.contact.displayEmail, contact.contact.hitQueryEmail, contact.contact.accountName].includes(userId)) {
                            continue;
                        }
                        doGetContactInMailListParams.emailList.push(contactItem.contactItemVal);
                        contactItems.push(transContactModel2ContactItem(contact));
                        chosenMemberItems.push(contact);
                    }
                    else {
                        otherContactItems.push(Object.assign(Object.assign({}, transContactModel2ContactItem(contact)), { color: contact.contact.color }));
                    }
                }
                if (doGetContactInMailListParams.emailList.length > 0 || doGetContactInMailListParams.idList.length > 0) {
                    contactApi.doGetContactInMailList(doGetContactInMailListParams).then(res => {
                        setCurMailListIds(res);
                    });
                }
                setSelectList(contactItems);
                setChosenMembers(chosenMemberItems);
                setOtherContact(otherContactItems);
            });
        }
    }, [userId]);
    useEffect(() => {
        if (curMailListIds != null) {
            const mails = curMailListIds.mail;
            const mailList = [];
            const notMailList = [];
            selectedList.forEach(selected => {
                if (mails[selected.email]) {
                    mailList.push(selected);
                }
                else {
                    notMailList.push(selected);
                }
            });
            setSelectList(notMailList);
            setOtherContact(otherContact.concat(mailList));
        }
    }, [curMailListIds]);
    useEffect(() => {
        const curUser = systemApi.getCurrentUser();
        if (!curUser) {
            return;
        }
        setUserId(curUser.id);
        if (lodashGet(curUser, 'contact.contactInfo.length', 0) >= 2) {
            setCurContact(filterContactListByYunxin([curUser.contact])[0]);
        }
        else {
        }
        const contactId = lodashGet(curUser, 'contact.contact.id', '') || lodashGet(curUser, 'prop.contactId', '');
        if (!contactId || !contactId.length) {
            return;
        }
        contactApi
            .doGetContactByQiyeAccountId({
            idList: [contactId],
        })
            .then(res => {
            setCurContact(filterContactListByYunxin(res)[0]);
        });
    }, []);
    const handleTrack = (str) => {
        trackApi.track(str);
    };
    const close = () => {
        onCancel && onCancel();
    };
    const createTeam = async () => {
        var _a;
        if (!curContact) {
            return;
        }
        const queryIds = new Set(selectedList.map(item => {
            return item.id;
        }));
        if (!queryIds.size) {
            return;
        }
        const account = ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        const yunxinMap = await contactApi.batchEnsureYunxinByIds([...queryIds.values()], account);
        let members = [...yunxinMap.entries()].filter(([, info]) => info.yxid && info.yxid !== YUNXIN_NONE_SENTINEL).map(([, info]) => info.yxid);
        if (members.length === 1 && creatorType === 0) {
            openSession({
                sessionId: `p2p-${members}`,
                mode: 'normal',
            }, {
                createSession: true,
            });
            close();
            return;
        }
        setLoading(true);
        let option;
        if (creatorType === 0) {
            option = {
                name,
                owner: contactApi.findContactInfoVal(curContact.contactInfo, 'yunxin'),
                members: members.join(','),
                use_auto_name: 1,
            };
        }
        else {
            option = {
                owner: contactApi.findContactInfoVal(curContact.contactInfo, 'yunxin'),
                members: members,
                name,
                emailTid: tid,
                emailMid: props.mid,
            };
        }
        try {
            let ret;
            if (creatorType === 0) {
                ret = await imTeamApi.createTeam(option, false);
            }
            else {
                ret = await discussApi.createDiscuss(option, false);
            }
            if (ret === null || ret === void 0 ? void 0 : ret.success) {
                let sessionId = `team-${creatorType === 0 ? ret.data.team_id : ret.data.teamId}`;
                openSession({
                    sessionId,
                    mode: 'normal',
                }, {
                    createSession: true,
                });
                creatorType !== 0 && trackApi.track('pcMail_click_addNewMailChatPage_addSuccess');
            }
            close();
            setLoading(false);
        }
        catch (ex) {
            message.info(lodashGet(ex, 'message', getIn18Text('CHUANGJIANSHIBAI')));
            setLoading(false);
        }
    };
    const onNameChange = (e) => {
        setName(e.target.value);
    };
    const setMembers = (selectList, members) => {
        console.log('@@@handleSelect', selectList, members);
        setSelectList(selectList);
    };
    return (React.createElement("div", { className: styles.createTeamWrapper },
        React.createElement("div", { className: styles.titleBar },
            React.createElement("span", { "data-test-id": "im_create_team_modal_title", className: styles.title }, CreatorLabels[creatorType]['creatorTitle']),
            React.createElement("div", { "data-test-id": "im_create_team_modal_close_btn", className: styles.closeButton, onClick: close },
                React.createElement(CloseIcon, null))),
        React.createElement("div", { className: classnames('ant-allow-dark', styles.teamItem, styles.noShrink) },
            React.createElement("span", { className: styles.label }, CreatorLabels[creatorType]['groupTitleLabel']),
            React.createElement(Input, { "data-test-id": "im_create_team_modal_teamname_input", placeholder: CreatorLabels[creatorType]['placeholder'], value: name, onChange: onNameChange, className: styles.input, maxLength: 30, allowClear: true })),
        React.createElement("div", { className: classnames(styles.teamItem, styles.flex) },
            React.createElement("span", { className: styles.label }, CreatorLabels[creatorType]['selectGroupMember']),
            creatorType === 1 && otherContact.length > 0 && (React.createElement("div", { className: styles.notInGroupInfo },
                React.createElement("div", { className: styles.leftInfo },
                    React.createElement("div", { className: styles.infoIcon },
                        React.createElement(InfoTips, null)),
                    React.createElement("div", { className: styles.infoTxt }, `${otherContact.length}${CreatorLabels[creatorType]['notInGroupMemberInfo']}`)),
                React.createElement(Popover, { placement: "bottomRight", arrowPointAtCenter: true, content: React.createElement("div", { className: styles.memberList }, otherContact.map((item, index) => (React.createElement("div", { className: styles.cardItem, key: index },
                        React.createElement("div", { className: styles.leftAvatar },
                            React.createElement(AvatarTag, { user: {
                                    name: item.name,
                                    avatar: item.avatar,
                                    email: item.email,
                                    color: item.color,
                                } })),
                        React.createElement("div", { className: styles.memberInfo },
                            React.createElement("div", { className: styles.memberName }, item.name),
                            React.createElement("div", { className: styles.memberMail }, item.email)))))), onVisibleChange: (visable) => {
                        visable && handleTrack('pcMail_hover_addNewMailChatPage_seeNonInternalMember');
                    } },
                    React.createElement("a", { className: styles.rightInfo, type: "link" }, CreatorLabels[creatorType]['notInGroupMemberBtn'])))),
            React.createElement("div", { className: styles.chooseWrap }, curContact && (React.createElement(ContactIMModal, { type: CreatorConf[creatorType], showAddTeamBtn: creatorType === 1, order: ['enterprise', 'team', 'personal', 'recent'], disableCheckList: [transContactModel2ContactItem(curContact)], defaultSelectList: selectedList, excludeOrgTypes: [1, 2], accountRootKey: getMainAccount(), onChange: setMembers })))),
        React.createElement("div", { className: styles.buttonBox },
            React.createElement(Button, { "data-test-id": "im_create_team_modal_cancel_btn", onClick: () => {
                    handleTrack('pcMail_click_addNewMailChatPage_addCancel');
                    close();
                } }, getIn18Text('QUXIAO')),
            React.createElement(Button, { "data-test-id": "im_create_team_modal_create_btn", type: "primary", loading: loading, className: styles.confirmButton, onClick: createTeam, disabled: !selectedList.length }, getIn18Text('CHUANGJIAN')))));
};
export const TeamCreatorPage = props => {
    const { visible, onClose } = props;
    return (React.createElement(Modal, { width: 640, visible: visible, closable: false, footer: null },
        React.createElement(TeamCreator, { creatorType: 0, onCancel: onClose })));
};
export const TeamContactModel = props => {
    const { show } = props;
    return (React.createElement(React.Fragment, null, show && (React.createElement("div", { className: classnames({
            [styles.teamCreatorWrapperNoLeft]: systemApi.isWebWmEntry(),
            [styles.teamCreatorWrapper]: true,
        }), style: { top: `${getBodyFixHeight(false, true)}px` } },
        React.createElement(TeamCreator, Object.assign({}, props))))));
};
export default TeamCreator;
